
class FindCentreMap {
    
    constructor() {

      this.selectProvinces = document.querySelector('select.provinces');
      this.listProvinces = document.querySelectorAll("[data-province]");
      this.svgProvinces = document.querySelectorAll("#napa-map .province");
      this.activeProvince = false; // current active province page

      if ( this.svgProvinces == null ) return false;

      this.init();
      this.letterNav();
    }

    init() {


      var $this = this;

      if ( document.body.contains(document.querySelector('.find-centre__city') ) && this.selectProvinces !== null ) {

        this.activeProvince = this.selectProvinces.querySelector('[selected]').getAttribute('data-province');

        this.selectProvinces.addEventListener("change", function() {
            window.location.href = this.value;
        });

      }

      this.listProvinces.forEach(function(el) {

        el.addEventListener("mouseenter", function() {
          $this.addOnFromList(el);
        });
        el.addEventListener("mouseleave", function() {
           $this.removeAllOn();
        });
        el.addEventListener("touchstart", function() {
          $this.removeAllOn();
          $this.addOnFromList(el);
        });
      });

      this.svgProvinces.forEach(function(el) {
        el.addEventListener("mouseenter", function() {
          $this.addOnFromProvince(el);
        });
        el.addEventListener("mouseleave", function() {
           $this.removeAllOn();
        });
        el.addEventListener("click", function(e) {
           e.preventDefault();
           $this.clickFromProvince(el);
        });
        el.addEventListener("touchstart", function() {
          $this.removeAllOn();
          $this.addOnFromProvince(el);
        });

        // In single province view, highlight active province in single page
        if($this.activeProvince == el.getAttribute('id')) {
          el.classList.add("active");
        }

      });


    }

    removeAllOn() {

      this.listProvinces.forEach(function(el) {
        el.classList.remove("on");
      });
      this.svgProvinces.forEach(function(el) {
        el.classList.remove("on");
      });
    }

    addOnFromList(el) {
      var provinceCode = el.getAttribute("data-province");
      var svgProvince = document.querySelector("#" + provinceCode);
      if (svgProvince != null) {
        el.classList.add("on");
        svgProvince.classList.add("on");
      }
    }

    addOnFromProvince(el) {
      var provinceId = el.getAttribute("id");
      var listProvince = document.querySelector("[data-province='" + provinceId + "']");
      el.classList.add("on");
      listProvince.classList.add("on");
    }

    clickFromProvince(el) {
      var provinceId = el.getAttribute("id");
      var listProvince = document.querySelector("[data-province='" + provinceId + "']");

      window.location.href = listProvince.getAttribute("href") || listProvince.getAttribute("value");

    }

    letterNav() {

      let container = document.querySelector('.find-centre__citylist');

      if ( !document.body.contains(container) ) return false;

      let letters      = container.querySelectorAll('[data-letter-handle]');
      let lettersGroup = container.querySelectorAll('[data-letter-group]');
      let btnAll       = container.querySelector('[data-all]');

      letters.forEach(function(el) {
        let letter = el.getAttribute('data-letter-handle');
        el.addEventListener("click", function(e) {

          e.preventDefault();

          let targetGroup = container.querySelector("[data-letter-group='" + letter + "']");
          if (targetGroup !== null) {

            letters.forEach( el => el.classList.add('disabled') );
            lettersGroup.forEach( el => el.classList.add('disabled') );

            el.classList.remove('disabled');
            targetGroup.classList.remove('disabled');
            btnAll.classList.remove('disabled');

            // Scroll down if sm breaking point
            let screenSize = window.getComputedStyle(document.body,':after').getPropertyValue('content');
            if( screenSize[0] == '"' || screenSize[0] == "'") {
              screenSize = screenSize.substring( 1, screenSize.length - 1 );
            }
            if ( screenSize == "xs" || screenSize == "sm" ) {
              $('html, body').animate( { scrollTop: $(targetGroup).offset().top + 3 }, 600, 'easeInOutExpo');
            }

          }
        });
      });

      btnAll.classList.add('disabled'); // All button disabled by default
      btnAll.addEventListener("click", function(e) {

          e.preventDefault();

          if (btnAll.classList.contains('disabled')) return;

          this.classList.add('disabled');
          letters.forEach( el => el.classList.remove('disabled') );
          lettersGroup.forEach( el => el.classList.remove('disabled') );

      });
    }

}

export default FindCentreMap;



// WEBPACK FOOTER //
// ./scripts/components/findcentremap.js